import React from 'react';
import { useEffect } from 'react'
import { Button } from '@/components/ui/button';

function Contact() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>

      <div className='mx-auto text-center max-w-prose my-24 xl:my-36 px-8'>
        <div className=' text-black'>
          {/* <p className="text-3xl font-custom  mb-12">
            Get in touch
          </p> */}
          <div
            className='my-12'>
            <p className="text-lg font-sans">
              All enquiries:</p>
            <p className="text-3xl font-kalice  mb-12">
              hello@antoia.com
            </p>
          </div>
          <div
            className='my-12'>
            <p className="text-lg font-sans">
              Atelier:</p>
            <p className="text-3xl font-kalice  mb-12">
              <a
              className=' text-black font-kalice font-medium italic  hover:text-black'>Palais d'Antoia</a> <br></br>
              Sint-agathastraat 54 <br></br>
              3037 SH Rotterdam <br></br>
              The Netherlands
            </p>
          </div>
          <div className='flex flex-col space-y-0 my-12'>
          <p className="text-lg font-sans">
              Talk to us:</p>
            <Button
  asChild
  variant="link"
  className="group font-kalice font-medium text-3xl hover:no-underline text-black hover:text-gray-700"
>
  <a href="https://wa.me/31613438650" target="_blank" rel="noopener noreferrer">
    Whatsapp
    <span className="inline-block ml-2 transition-transform duration-300 group-hover:translate-x-4">
      →
    </span>
  </a>
</Button>
{/* <Button
  asChild
  variant="link"
  className="group font-kalice font-medium text-3xl hover:no-underline text-black hover:text-gray-700"
>
  <a href="https://wa.me/yourwhatsapplink" target="_blank" rel="noopener noreferrer">
    Calls & Bookings
    <span className="inline-block ml-2 transition-transform duration-300 group-hover:translate-x-4">
      →
    </span>
  </a>
</Button> */}
          </div>
{/*           <div className='flex-1 h-full'>
              <Button className="w-[100%] mb-2" variant="">Call</Button>
              <Button className="w-[100%] mb-2" variant="">WhatsApp</Button>
              <Button className="w-[100%]" variant="">Schedule a visit</Button>
            </div> */}
          <div
            className='my-12'>
            <p className="text-md font-sans text-[#706f6f]">
  ©{" "}
  {new Date().toLocaleString("en-GB", {
    timeZone: "Europe/Amsterdam",
    year: "numeric",
  })}
</p>

          </div>
        </div>
      </div>

      {/* <div className='relative mb-2 mx-2'>
        <img
          src={"/src/assets/images/museumcircle_banner00.jpg"}
          alt={`${"hello"} Hover`}
          className="w-full h-[32rem] object-cover rounded-3xl "
        />
      </div> */}

    </>
  );
}

export default Contact;
